<template>
    <div class="tpl-page-container">

               <SideBar></SideBar>
        <MainView></MainView>
    </div>
</template>

<script>
     import SideBar from '@/components/common_components/side_bar/side_menu.vue'
    import MainView from '@/apps/plan/sub_components/plan_notes.vue'
    export default {
        name: "mynotes",
        components: {
            SideBar,
            MainView,
        },
    }
</script>

<style scoped>

</style>